module.exports = __webpack_public_path__ + "img/logout.88a023f1.svg";